import ConsumoView from "./ConsumoView";
export default ConsumoView;